// lib
import React, { useContext } from 'react'
import { match, useHistory } from 'react-router-dom'

// components
import { URLContext } from 'src/containers/url_provider/url_provider'

// interfaces & constants

// helpers
import { ContentItemQuery } from '@lopo-tech/lopo-api'
import { useFeatureFlags } from '@lopo-tech/frontends-shared'
import PostHeaderDetails from 'src/components/header/subheaders/pages/post_details/post_header_details'
import { useIsPostUpdateOpen } from 'src/pages/hooks/hooks'
import { UrlUtils } from 'src/utils/url/url'

interface IProps {
  match: match;
  contentItem: ContentItemQuery['contentItem'];
}

const PostHeaderDetailsContainer: React.FC<IProps> = ({ contentItem, match }) => {
  const history = useHistory()

  const postUpdateOpen = useIsPostUpdateOpen(match)
  const features = useFeatureFlags()

  const { getEventsfeedRoute, getNewsfeedRoute } = useContext(URLContext)
  // The events feed is only a valid destination while the events feature is on.
  // Everything else — other content types, and a content item that has not
  // resolved yet — falls back to the newsfeed.
  const goToFallback =
    contentItem?.__typename === 'Event' && features.events
      ? getEventsfeedRoute()
      : getNewsfeedRoute()
  const handleBackButton = () => {
    UrlUtils.goBack(history, goToFallback)
  }

  return (
    <PostHeaderDetails
      handleBackButton={handleBackButton}
      contentItem={contentItem}
      postUpdateOpen={postUpdateOpen}
    />
  )
}

export default PostHeaderDetailsContainer
